import { useEffect, useState } from 'react';

/** Coarse "available in Xh Ym" / "available in Xd Yh" countdown label for
 * `SpinStatus.nextEligibleAt`. Re-renders once a minute -- minute-precision
 * is intentional per the milestone brief ("doesn't need second-precision").
 * Returns `null` once the deadline has passed (caller should treat that as
 * "may be eligible again -- refetch status"). */
export function useCountdownLabel(targetIso: string | null): string | null {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!targetIso) return;
    const interval = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(interval);
  }, [targetIso]);

  if (!targetIso) return null;
  const target = new Date(targetIso).getTime();
  if (Number.isNaN(target)) return null;
  const diffMs = target - now;
  if (diffMs <= 0) return null;

  const totalMinutes = Math.ceil(diffMs / 60_000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) return `available in ${days}d ${hours}h`;
  if (hours > 0) return `available in ${hours}h ${minutes}m`;
  return `available in ${minutes}m`;
}
